const BULK_PACKAGING_KEYWORDS = ['tolva', 'granel'];

export const normalizePackagingTypeName = (value = '') =>
  `${value}`
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const isBulkPackagingType = (packagingType) => {
  const name =
    typeof packagingType === 'string' ? packagingType : packagingType?.name;
  const normalizedName = normalizePackagingTypeName(name);

  return BULK_PACKAGING_KEYWORDS.some(
    (keyword) =>
      normalizedName === keyword || normalizedName.includes(keyword),
  );
};
